import React, { useState, useEffect, useRef, useContext, useLayoutEffect,Fragment  } from 'react';

import { SideBarContext,LayoutContext } from '_context/LayoutContext';
import { MapContext } from '_context/MapContext';
import { useWindowSize } from '_context/commonHooks';

import { getItem } from '_services/agent';

import { PlaceList, AddrResult } from 'component/PlaceList';
import { Footer } from 'component/Footer';
import { Loading } from 'component/Loading';
import util from '../common/util';

import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import KTMap from './KTMap';
let now = new Date().getTime();

const SearchResult = ({search,setHistory}) => {
  const [poiData, setPoiData] = useState([]);
  const [addrData, setAddrData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const tPoint = useRef(null); //thisPoint를 임시로 가지고 있는 변수 (이 위치 재검색시 포인트임)
  
  const [pages, setPages] = useState({
      pageCount : null,
      pageIndex : 0,
      pageTotal : 0,
      addrTotal : 0,
      sort : "relevance",
      rememberPoint:null
  })
 
  const [addrheight, setHeight] = useState(0);
  const [ addrBlock, setAddrBlock ] = useState(true);
  const { setPoi, selectedPoi, selectedId, ktMapIns, thisPoint } = useContext(MapContext);
  const { sidebar } = useContext(SideBarContext);
  const server_Data = useRef(null);
  const { status } = useContext(LayoutContext);

  useEffect(() => {
    setPageIndex(0,false);
  }, [search]);

  useEffect(()=>{
    if(thisPoint && thisPoint.x && thisPoint.y){
      tPoint.current = thisPoint
      //pages.rememberPoint = point
      if(pages.sort==='relevance'){
        onChange("sort","distance")
      }else{
        setPageIndex(0,true,thisPoint);
      }
    }
  },[thisPoint])

  useEffect(() => {
    if(status=='search' && server_Data.current){
      var boundTimer
      boundTimer = setInterval(function() {
          clearInterval(boundTimer);
          
          serverDataDispose(server_Data.current);
      },50);
    }else{
      setPoi({});
    }
  }, [status]);


  useEffect(() => {
    onChange("pageCount",0)
    if(search){
      fetchData(pages.pageIndex);
    }else{
      server_Data.current = null
      setPoi(null)
    }
  }, [search, pages.sort]);

  const poiRef = useRef();
  const addrRef = useRef();
  const size = useWindowSize(addrRef); 

  useEffect(() => {
    if(poiRef.current===undefined){return }
    if(sidebar && selectedId){
    var elem = document.getElementById("list-"+selectedId);
    if(poiRef.current){
      let poiInstance =  poiRef.current.osInstance();
      if(poiInstance && elem){
        poiInstance.scroll(elem,500);
      }
    }
   }
   },[selectedId]);
  
 const setPageIndex = (idx,mode, point) => {
   onChange("pageIndex",idx)
   if(mode){fetchData(idx, point);}
 }

  const onChange = (name,value) => {
    setPages({
      ...pages, 
      [name]: value 
    });
  };

  async function fetchData(pageIndex, point){
    if(!ktMapIns){
      return
    }

   setLoading(true);
   let sort = pages.sort
   if(tPoint.current){
    let latlng = util.utmkToLatlng(tPoint.current.x, tPoint.current.y)
    point = {lat: latlng.x, lng: latlng.y}
    tPoint.current = null //초기화 한다. 이 위치 재검색시 포인트임.
    pages.rememberPoint = {lat: latlng.x, lng: latlng.y}
   }else{
    if(!point){
      let centerPoint = ktMapIns.getCenter()
      let latlng = util.utmkToLatlng(centerPoint.x, centerPoint.y)
      point = {lat: latlng.x, lng: latlng.y}
    }else{
      let latlng = util.utmkToLatlng(point.x, point.y)
      point = {lat: latlng.x, lng: latlng.y}
      sort = 'distance'
    }
   }

   let pointParm = {lat: 37.570026282477116, lng: 126.97714803962387}
   if(pageIndex===0 && (!pages.rememberSearch || pages.rememberSearch!==search)){
      pages.rememberPoint = point
      pages.rememberSearch = search
   }
   pointParm = pages.rememberPoint
    
   await getItem('poi','?sortBy='+sort+'&mode=NAVIGATION&numberOfResults=10&start='+(pageIndex*10),{
      point: pointParm,
      terms: search
    })
      .then(res => {
        setLoading(false);
        if(res.data.numberOfPois && res.data.numberOfPois>20000){
          res.data.numberOfPois = 20000
        }
        let serverData = res.data;
        server_Data.current = res.data
        serverDataDispose(serverData)
    }).catch(err => {
            setError(err);
            setLoading(false);
        }
    );
  };

  const serverDataDispose = (serverData)=>{
    setPoiData(serverData.pois);
    setAddrData(serverData.residentialAddress);
    setPages({
      ...pages,
      pageCount: Math.ceil(serverData.numberOfPois / 10),
      pageTotal: serverData.numberOfPois,
      addrTotal : serverData.numberOfAddress
    })

    setPoi(serverData);
    selectedPoi('');
    if(serverData.numberOfAddress > 0){
      let addrFlag = serverData.residentialAddress[0].parcelAddress.length?"parcelAddress":"roadAddress";
      let addrObj = serverData.residentialAddress[0][addrFlag][0];
      selectedPoi(addrFlag==="parcelAddress"?addrObj.pnucode:addrObj.rbucode);
      setHistory({"name":addrObj.fullAddress, "point":addrObj.geographicInformation.point, "timestamp":now})
    }else{
      if(serverData.pois.length>0 && serverData.pois[0]['id']){
        selectedPoi(serverData.pois[0].id);
        setHistory({"name":serverData.pois[0].name+(serverData.pois[0].branch?' '+serverData.pois[0].branch:'')+(serverData.pois[0].subName?' '+serverData.pois[0].subName:''), "point":serverData.pois[0].point, "timestamp":now})
      }
    }

    if(poiRef.current){
      let poiInstance =  poiRef.current.osInstance();
      if(poiInstance){
        poiInstance.scrollStop().scroll({
          x: 0,
          y: 0
        });
      }
    }
  }

  const chgHeight = (cnt)=>{
    if(!addrBlock){return 50;}
    else{
      if(cnt===0){return 0;}
      else if(cnt===1){return 140;}
      else if(cnt===2){return 228;}
      else if(cnt>3){return 320;}
    }
  }

  if(!search){  return null}
  let tmpH = window.document.body.offsetHeight-chgHeight(pages.addrTotal)-180;

  return (
      <div className={
        "wrapSchResult addressPlace " +
        (addrBlock?"":"wrapPlaceView ") +
        (sidebar?"":"hide")
      }
      style={{zIndex:20}}
      
      /*  className={sidebar?"wrapSchResult addressPlace":"wrapSchResult hide"} */>
      
      {
        pages.addrTotal > 0 &&  
        <div className={addrBlock?"wrapAddress":"wrapAddress hide"}>
        <AddrResult addrData={addrData} addrTotal={pages.addrTotal} addrBlock={addrBlock} setAddrBlock={setAddrBlock}  setHistory={setHistory}/>
        </div>     
      }
      
      <div className="wrapPlace">
      <div  className={
        "wrapTop " +
        (pages.addrTotal > 0 ?"":"onlyPoi ")
        }>
      <div className="resultNum">장소 <span className="num">{pages.pageTotal}</span>건 <span className="iconsArrow"></span></div>
      <div className="sort">
      <ul>
        <li><button className={pages.sort==="relevance"?"on":""}  onClick={() => onChange("sort","relevance")}><span>관련도순</span></button></li>
        <li><button className={pages.sort==="distance"?"on":""} onClick={() => onChange("sort","distance")}><span>거리순</span></button></li>
      </ul>
    </div>
    {/*<div className="btnWrap">
        <button className="btnToggle"><span className="btnsSch close"></span></button>
      </div> */}
      </div>
    
      <div className="plugin-scrollbar-bd">
      <div className="plugin-scrollbar">
      <OverlayScrollbarsComponent ref={poiRef}
      style={{ maxHeight: tmpH }}
      >
      { loading ?<Loading />:
      <div className="list">
      <ul>
      {poiData.map((row,i)=><PlaceList key={i} idx={i} obj={row} isActive={selectedId===row.id?true:false} setHistory={setHistory} />)}               
      </ul></div>
    }
      </OverlayScrollbarsComponent> 
      </div>
      </div>
    
      </div>
      <Footer pageCount={pages.pageCount} setPageIndex={setPageIndex}/>
      </div> 
    );
  };
  
  export default SearchResult;